import {Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BeaconService } from '../services/beacon.service';
import { DeviceService } from '../services/device.service';
import { PayvendService } from '../services/payvend.service';
import { SimcardService } from '../services/simcard.service';
import { ModemService } from "../services/modem.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

declare var $: any;

@Component({
    selector: 'app-having-firm',
    templateUrl: './having-firm.component.html',
    styleUrls: ['./having-firm.component.css']
})
export class HavingFirmComponent implements OnInit {
    devicesPage = 1;
    devicesPages = 2;
    selector: string = '.devices-list';
    search = '';
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    productypeName : string = '';
    data: any[] = [];
    model= new itemModel(); // Object for Bootstrap modals
    editModelName = ''; // Edit product modal title
    errorMessage = '';
    constructor(
        private route: ActivatedRoute, 
        private router: Router,
        private deviceService: DeviceService,
        private simcardService: SimcardService,
        private beaconService: BeaconService,
        private payvendService: PayvendService,
        private modemService: ModemService,
        private spinner: NgxSpinnerService) { }


    ngOnInit() {
        this.onScroll();
        this.productypeName = this.route.snapshot.paramMap.get('name');
        console.log(this.productypeName);
        switch (this.productypeName) {
            case 'Cihazlar':
                this.getAllDevicesForSuperAdmin();
                break;
            case 'Sim-Kartlar':
                this.simcardService.getSimsForSuperAdmin().subscribe( res => {
                    if (res.success) {
                        this.data = res.sims;
                    } else {
                        this.errorSwal.title = 'Hata!';
                        this.errorSwal.text = res.message;
                        this.errorSwal.show();
                        this.spinner.hide();
                    }
                }, error => {
                    if (error.message === 'Error: Access Denied') {
                        localStorage.removeItem('token');
                        localStorage.removeItem('user');
                        this.router.navigate(['/login']);
                        this.spinner.hide();
                    } else {
                        this.errorSwal.title = error.status;
                        this.errorSwal.text = error.error;
                        this.errorSwal.show();
                        this.spinner.hide();
                    }
                });
                break;
            case 'Beacon':
                this.beaconService.getAllBeaconsForSuperAdmin().subscribe( res => this.data = res);
                break;
            case 'POS':
                this.payvendService.getvPosesForSuperAdmin().subscribe( res => this.data = res);
                break;
            case 'Modem':
                this.modemService.getModemsForSuperAdmin().subscribe( res => this.data = res);
                break;
        
            default:
                break;
        }
    }

    setModel(model) {
        console.log(model);
        this.clearModel();
        this.model = Object.assign({}, model);
        //this.editModelName = model.name;
    }

    onSearchText(e) {
        this.search = e;
        this.devicesPage = 1;
        this.getAllDevicesForSuperAdmin();
    }

    getAllDevicesForSuperAdmin() {
        this.deviceService.getAllDevicesForSuperAdmin(this.devicesPage, this.search).subscribe( res => {
            this.data = res.docs;
            this.devicesPages = res.pages;
        });
    }
    
    onScroll() {
        if (this.devicesPage + 1 > this.devicesPages) { return; }
        $('#page-loader').fadeIn();
        this.devicesPage += 1;
        this.deviceService.getAllDevicesForSuperAdmin(this.devicesPage, this.search)
            .subscribe(response => {
                $('#page-loader').fadeOut();
                for (const item of response.docs) {
                    this.data.push(item);
                }
                this.devicesPages = response.pages;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
                this.errorSwal.show();
            });
      }

    clearModel() {}
    updateModel() {}

}
export class itemModel{
    name?: string;
}


// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/having-firm/having-firm.component.ts